import { cosmosConfig } from "@/modules/cosmos/constants/cosmos"

interface CosmosConfig {
  colors: {
    primary: {
      50: string
      100: string
      200: string
      300: string
      400: string
      500: string
      600: string
      700: string
      800: string
      900: string
    }
    alternatives: string[]
  }
  meta: {
    title: string
    logoUrl: string
    faviconUrl: string
  }
  onboarding: {
    videoUrl: string
  }
}

interface GetCosmosResponse {
  description: {
    config: CosmosConfig
  }
}

enum COSMOS_KEY {
  DEFAULT = "default",
  MENDOZA = "mendoza",
  SIGLO21 = "siglo21",
}

export function get(cosmosKey: COSMOS_KEY) {
  return new Promise<GetCosmosResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        description: {
          config: cosmosConfig[cosmosKey],
        },
      })
    }, 0)
  })
}
